import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Footer from "../../Components/Common/Footer";
import {
  Box, Typography, Card, CardContent,  Container, IconButton,DialogTitle, DialogContent, DialogActions,
 Chip,Paper, Grid, Stack,Dialog,Button,TextField, Rating, MenuItem, Select, FormControl, InputLabel,
  CircularProgress
} from "@mui/material";
import {
   Visibility as EyeIcon, Download as DownloadIcon, InsertDriveFile as FileIcon,
  PictureAsPdf as PdfIcon, Image as ImageIcon,Description as DescriptionIcon,  Close as CloseIcon
} from '@mui/icons-material';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CustomDialog from "../../CustomDialog";
import { apiRequest } from '../../fetchSetup';
import { useState,useEffect } from "react";
import { fetchUserFromRedis } from "../../Components/HomePage/AuthonticationScreens/Register";
import axios from 'axios';

  const SINGLE_STATUS_COLOR = { bg: "#DBEAFE", text: "#1D4ED8" };

  const STATUS_COLORS = {
    new: SINGLE_STATUS_COLOR,
    pending: SINGLE_STATUS_COLOR,
    confirmed: SINGLE_STATUS_COLOR,
    "sample-collected": SINGLE_STATUS_COLOR,
    "test-in-progress": SINGLE_STATUS_COLOR,
    "report-ready": SINGLE_STATUS_COLOR,
    "report-delivered": SINGLE_STATUS_COLOR,
    completed: SINGLE_STATUS_COLOR,
    cancelled: SINGLE_STATUS_COLOR,
  };
const BookingDetailsPage = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const booking = state?.booking;
  const BOOKED_SERVICES_API = process.env.REACT_APP_BOOKED_SERVICES_API;
  const complaintsAPI = process.env.REACT_APP_COMPLAINTS_API;
  const feedbackAPI = process.env.REACT_APP_SERVICE_FEEDBACK_API;
  const updateBookingApi = process.env.REACT_APP_UPDATE_BOOKINGS;
  const DOWNLOAD_REPORT_API = process.env.REACT_APP_DOWNLOAD_DIAGNOSTIC_REPORT;
  const [customDialog, setCustomDialog] = useState({ show: false, message: '', title: '', type: 'success' });
  const [previewContent, setPreviewContent] = useState(null);
  const [previewDialogOpen, setPreviewDialogOpen] = useState(false);
  const [previewFile, setPreviewFile] = useState(null);
  const [validationDialogOpen, setValidationDialogOpen] = useState(false);
  const [validationMessage, setValidationMessage] = useState("");
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogType, setDialogType] = useState("");
  const [loading, setLoading] = useState(true);
  const [issuesDialog, setIssuesDialog] = useState({ open: false, booking: null });
  const [user, setUser] = useState(null);
  const [bookings, setBookings] = useState([]);
  const [refreshing, setRefreshing] = useState(false);
  
  
  const [selectedBooking, setSelectedBooking] = useState(booking);

  const [formData, setFormData] = useState({
    rating: 0,
    comment: "",
    category: "",
    date: "",
    cancellation_reason: "",
    reschedule_reason: ""  
  });
  const [previewDialog, setPreviewDialog] = useState({ 
      open: false, 
      url: null, 
      type: null, 
      filename: null 
    });
     useEffect(() => {
      const fetchUser = async () => {
        const userId = sessionStorage.getItem("userId");
        const token = sessionStorage.getItem("token");
        if (!userId || !token) {
          setUser(null);
          setLoading(false);
          return;
        }
        try {
          const userData = await fetchUserFromRedis(userId, token);
          setUser(userData || null);
        } catch (err) {
          console.error("Error fetching user from Redis:", err);
          setUser(null);
        } finally {
          setLoading(false);
        }
      };
      fetchUser();
    }, []);
  
useEffect(() => {
  if (booking.booking_id) {
    fetchBookings();
  }
},[]);

  if (!booking) {
    return (
      <Box sx={{ p: 4 }}>
        <Typography variant="h6" color="text.secondary">
          No booking found
        </Typography>
      </Box>
    );
  }
  
  const handleSubmit = async () => {
      setLoading(true);
      if (!selectedBooking) return;
  
      if (dialogType === "reschedule") {
        const selectedDate = new Date(formData.date);
      
        if (selectedDate < now || selectedDate > maxDate) {
          setValidationMessage(
            "Please select a date between now and the next 10 days."
          );
          setValidationDialogOpen(true);
          setLoading(false);
          return;
        }
                // ✅ NEW: Time validation (6 AM – 6 PM)
          const hours = selectedDate.getHours();

          if (hours < 6 || hours >= 18) {
            setValidationMessage(
              "Please select a time between 6:00 AM and 6:00 PM."
            );
            setValidationDialogOpen(true);
            setLoading(false);
            return;
          }


      
        if (!formData.reschedule_reason) {
          setValidationMessage("Please provide a reason for rescheduling!");
          setValidationDialogOpen(true);
          setLoading(false);
          return;
        }
      }
      
      if (dialogType === "cancel" && !formData.cancellation_reason) {
        setValidationMessage("Please provide a reason for cancellation!");
        setValidationDialogOpen(true);
        setLoading(false);
        return;
      }
      
      if (dialogType === "feedback" && !formData.rating) {
        setValidationMessage("Please select a rating!");
        setValidationDialogOpen(true);
        setLoading(false);
        return;
      }
  
      if (dialogType === "complaint" && !formData.category) {
        setValidationMessage("Please select a category!");
        setValidationDialogOpen(true);
        setLoading(false);
        return;
      }
  
      let endpoint = "";
      let payload = {};
      let method = "POST";
  
      if (dialogType === "complaint") {
        endpoint = `${complaintsAPI}/${selectedBooking.booking_id}`;
        payload = {
          resident_id: user.user_id,
          rating: formData.rating,
          comment: formData.category === "other" ? formData.comment : `${formData.category} - ${formData.comment}`,
          category: formData.category,
          status: "open",
        };
      } else if (dialogType === "reschedule") {
        endpoint = `${updateBookingApi}/${selectedBooking.booking_id}`;
        payload = { date: formData.date,reschedule_reason: formData.reschedule_reason,action: "reschedule" };
        method = "PUT";
      } else if (dialogType === "cancel") {
        endpoint = `${updateBookingApi}/${selectedBooking.booking_id}`;
        payload = { action: "cancel", status: "cancelled", cancellation_reason: formData.cancellation_reason };
        method = "PUT";
      } else {
        endpoint = `${feedbackAPI}/${selectedBooking.booking_id}`;
        payload = { rating: formData.rating, comment: formData.comment };
      }
  
      try {
        const res = await apiRequest(endpoint, {
          method,
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });
  
        const data = await res.json();
        if (res.ok) {
          setValidationMessage(data.message || "Success!");
          setValidationDialogOpen(true);
          handleCloseDialog();
          fetchBookings();
          if (data.booking) {
              setSelectedBooking(data.booking);
            }
         

        } else {
          setValidationMessage("Error: " + data.error);
          setValidationDialogOpen(true);
        }
      } catch (err) {
        console.error("Submit error:", err);
        setValidationMessage("Failed to submit. Please try again.");
        setValidationDialogOpen(true);
      } finally {
        setLoading(false);
      }
    };
      const fetchBookings = async () => {
        if (!booking) return;
        try {
          const params = new URLSearchParams({
            booking_id: booking.booking_id,
          });
          const res = await apiRequest(`${BOOKED_SERVICES_API}/id?${params}`);
          const data = await res.json();
          if (res.ok) {
            const sortedBookings = data.booking
            setBookings(sortedBookings);
            setSelectedBooking(sortedBookings)
          }
        } catch (err) {
          console.error("Fetch error:", err);
        } finally {
          setRefreshing(false);
        }
      };

 const handleOpenDialog = (type, booking) => {
    setDialogType(type);
    setSelectedBooking(booking);
    setFormData({ rating: 0, comment: "", category: "", date: "", cancellation_reason: "" });
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };
  const now = new Date();
const minDateTime = now.toISOString().slice(0, 16);

// Max date = now + 10 days
const maxDate = new Date();
maxDate.setDate(maxDate.getDate() + 10);
const maxDateTime = maxDate.toISOString().slice(0, 16);

const convertOffsetISOToLocalInput = (isoString) => {
  if (!isoString) return "";

  const date = new Date(isoString);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  return `${year}-${month}-${day}T${hours}:${minutes}`;
};

  const canModifyBooking = (status) => {
    const blockedStatuses = [
      "agent_assigned", 
      "sample-collected",
      "test-in-progress", 
      "report-ready",
      "report-packed",
      "report-dispatched",
      "report-out-for-delivery",
      "report-delivered",
      "closed", 
      "cancelled",
      "rescheduled",
      "pending_agent_response",
      "sample_collection_reschedule",
      "sample_collection_cancelled"
    ];
  
    return !blockedStatuses.includes(status);
  };

  const getCombinedIssues = (booking) => {
    if (!booking) return [];
    
    const issues = [];
    
    // Handle delivery_issues
    if (booking.delivery_issues && Array.isArray(booking.delivery_issues)) {
      booking.delivery_issues.forEach((issue, index) => {
        issues.push({
          ...issue,
          issue_id: issue.issue_id || `DI-${booking.booking_id}-${index}`,
          source: 'delivery_issue',
          issue_category: 'Delivery Issue',
          issue_type: issue.issue_type || 'delivery_issue',
          description: issue.description || 'No description',
          reported_at: issue.reported_at || new Date().toISOString(),
          reported_by: issue.reported_by || 'System',
          status: issue.status || 'open'
        });
      });
    }
    
    // Handle collection_failures - THIS IS THE KEY FIX!
    if (booking.collection_failures && Array.isArray(booking.collection_failures)) {
      booking.collection_failures.forEach((failure, index) => {
        const issueId = failure.issue_id || `CF-${booking.booking_id}-${index}`;
        
        // Build description from MongoDB fields
        const description = failure.failure_details || 
                           `${failure.failure_reason || 'Collection Failed'}: ${failure.additional_notes || 'See details'}`;
        
        issues.push({
          issue_id: issueId,
          issue_type: failure.failure_type || 'collection_failure',
          description: description,
          reported_at: failure.reported_at || new Date().toISOString(),
          reported_by: failure.reported_by || 'Collector',
          status: failure.status || 'open',
          photo_url: failure.photo_url || null,
          source: 'collection_failure',
          issue_category: 'Sample Collection Failure',
          
          // Keep all MongoDB fields
          failure_reason: failure.failure_reason,
          failure_details: failure.failure_details,
          can_reschedule: failure.can_reschedule,
          suggested_reschedule_time: failure.suggested_reschedule_time,
          patient_available: failure.patient_available,
          address_issue: failure.address_issue,
          additional_notes: failure.additional_notes
        });
      });
    }
    
    // Sort by date
    issues.sort((a, b) => new Date(b.reported_at) - new Date(a.reported_at));
    
    return issues;
  };

 const handleDownloadReport = async (
     bookingId,
     filename,
     originalFilename
   ) => {
     try {
       console.log("Download request:", { bookingId, filename });
   
       const response = await apiRequest(
         `${DOWNLOAD_REPORT_API}/${bookingId}/${filename}`,
         { method: "GET" }
       );
   
       if (!response.ok) {
         const errorText = await response.text();
         throw new Error(`Download failed: ${errorText}`);
       }
   
       const contentType = response.headers.get("content-type");
   
       if (contentType?.includes("application/json")) {
         const data = await response.json();
   
         if (!data.download_url) {
           throw new Error("No download URL received");
         }
   
         // ✅ FORCE DOWNLOAD VIA NEW TAB
         window.open(data.download_url, "_blank");
         return;
       }
   
       const blob = await response.blob();
   
       if (!blob || blob.size === 0) {
         throw new Error("Empty file received");
       }
   
       const url = URL.createObjectURL(blob);
   
       const a = document.createElement("a");
       a.href = url;
       a.download = originalFilename || filename;
       document.body.appendChild(a);
       a.click();
   
       document.body.removeChild(a);
       URL.revokeObjectURL(url);
   
     } catch (err) {
       console.error("Download error:", err);
       setValidationMessage(`Download failed: ${err.message}`);
       setValidationDialogOpen(true);
     }
   };
   
    const handleClosePreviewDialog = () => {
    setPreviewDialogOpen(false);
    if (previewContent?.url) {
      URL.revokeObjectURL(previewContent.url);
    }
    setPreviewContent(null);
    setPreviewFile(null);
  };
 const showCustomDialog = (message, type = 'success', title = 'Notification') => {
    setCustomDialog({ show: true, message, type, title });
  };
const handlePreviewReport = async (
    bookingId,
    filename,
    fileType,
    originalFilename
  ) => {
    try {
      console.log("Preview request:", { bookingId, filename });
  
      const response = await apiRequest(
        `${DOWNLOAD_REPORT_API}/${bookingId}/${filename}`,
        { method: "GET" }
      );
  
      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Preview failed: ${errorText}`);
      }
  
      const contentType = response.headers.get("content-type");

      if (contentType?.includes("application/json")) {
        const data = await response.json();
  
        if (!data.download_url) {
          throw new Error("No preview URL received");
        }
  
        // ✅ SHOW IN PREVIEW DIALOG (NO DOWNLOAD)
        setPreviewDialog({
          open: true,
          url: data.download_url,
          type: fileType || "unknown",
          filename: originalFilename || filename
        });
  
        return;
      }
  
      const blob = await response.blob();
  
      if (!blob || blob.size === 0) {
        throw new Error("Empty file received");
      }
  
      const previewUrl = URL.createObjectURL(blob);
  
      setPreviewDialog({
        open: true,
        url: previewUrl,
        type: fileType || blob.type,
        filename: originalFilename || filename
      });
  
    } catch (err) {
      console.error("Preview error:", err);
      setValidationMessage(`Preview failed: ${err.message}`);
      setValidationDialogOpen(true);
    }
  };
  

    const isImageFile = (filename) => {
    const ext = filename.split('.').pop().toLowerCase();
    return ['png', 'jpg', 'jpeg', 'gif', 'bmp', 'webp'].includes(ext);
  };
const isPdfFile = (filename) => {
    const ext = filename.split('.').pop().toLowerCase();
    return ext === 'pdf';
  };
 const handleCloseCustomDialog = () => {
    setCustomDialog({ show: false, message: '', type: 'success', title: '' });
  };
    const handleClosePreview = () => {
    if (previewDialog.url) {
      window.URL.revokeObjectURL(previewDialog.url);
    }
    setPreviewDialog({ open: false, url: null, type: null, filename: null });
  };
    const handleInvoiceDownload=async(order_id)=>{
      try {
            const token = sessionStorage.getItem("token");

            const response = await axios.get(
              `${process.env.REACT_APP_API_INVOICE}/diagnostic-invoice/download/${order_id}`,
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            );
            const download_url=response.data.download_url
            window.open(download_url, "_blank");
          } catch (error) {
            console.error("Invoice download failed:", error);
          }
}


    
  const getFileIcon = (fileName) => {
      if (!fileName || typeof fileName !== "string") {
        return <FileIcon sx={{ fontSize: 40, color: '#6B7280' }} />;
      }
    
      const parts = fileName.split(".");
      if (parts.length < 2) {
        return <FileIcon sx={{ fontSize: 40, color: '#6B7280' }} />;
      }
    
      const ext = parts.pop().toLowerCase();
    
      switch (ext) {
        case "pdf":
          return <PdfIcon sx={{ fontSize: 40, color: '#EF4444' }} />;
        case "png":
        case "jpg":
        case "jpeg":
          return <ImageIcon sx={{ fontSize: 40, color: '#3B82F6' }} />;
        case "doc":
        case "docx":
          return <DescriptionIcon sx={{ fontSize: 40, color: '#2563EB' }} />;
        default:
          return <FileIcon sx={{ fontSize: 40, color: '#6B7280' }} />;
      }
    };
    

  const getStatusColor = (status) => STATUS_COLORS[status] || STATUS_COLORS.pending;
  const statusInfo = getStatusColor(booking.status);
const formatDate = (dateString) => {
  if (!dateString) return "N/A";
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "Invalid Date";
    
    // ✅ Add timeZone: 'Asia/Kolkata' to ensure IST
    return date.toLocaleDateString('en-IN', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      timeZone: 'Asia/Kolkata'  // ← THIS IS THE FIX!
    });
  } catch (error) {
    return "N/A";
  }
};

 const formatTime = (dateString) => {
    if (!dateString) return "N/A";
  
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return "Invalid Date";
  
      // Add 5 hours 30 minutes (IST offset)
      date.setHours(date.getHours() + 5);
      date.setMinutes(date.getMinutes() + 30);
  
      return date.toLocaleTimeString("en-IN", {
        hour: "numeric",
        minute: "2-digit",
        hour12: true
      });
    } catch (error) {
      console.error("Error formatting time:", error);
      return "N/A";
    }
  };

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "#F9FAFB" }}>
      
      {/* Header */}
      <Paper elevation={2} sx={{ bgcolor: "#fff", mb: 3 }}>
        <Container maxWidth="lg">
          <Box sx={{ py: 2, display: "flex", alignItems: "center", gap: 2 }}>
            <IconButton
                            onClick={() => window.history.back()}
                            sx={{
                              backgroundColor: "white",
                              boxShadow: 1,
                              flexShrink: 0,
                              "&:hover": { backgroundColor: "#f5f5f5" },
                            }}
                          >
                            <ArrowBackIcon />
                          </IconButton>
            <Typography variant="h4" sx={{ color: "#006D77", fontWeight: 600 }}>
              Booking Details
            </Typography>
          </Box>
        </Container>
      </Paper>

      {/* Booking Summary */}
      <Container maxWidth="lg" sx={{ mb: 4 }}>
        <Paper elevation={1} sx={{ p: 3, borderRadius: 3 }}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <Typography fontWeight={600}>Service</Typography>
              <Typography color="text.secondary">{selectedBooking.service_type}</Typography>
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography fontWeight={600}>Booking ID</Typography>
              <Typography color="text.secondary">#{selectedBooking.booking_id}</Typography>
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography fontWeight={600}>Patient</Typography>
              <Typography color="text.secondary">
                {selectedBooking.guest_name} ({selectedBooking.age}y • {selectedBooking.gender})
              </Typography>
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography fontWeight={600}>Date & Time</Typography>
              <Typography color="text.secondary">
                {formatDate(selectedBooking.date)} | {formatTime(selectedBooking.date)}
              </Typography>
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography fontWeight={600}>Amount</Typography>
              <Typography sx={{ color: "#006D77", fontWeight: 700 }}>
                ₹{selectedBooking.payment?.amount}
              </Typography>
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography fontWeight={600}>Status</Typography>
              <Chip
                label={selectedBooking.status}
                sx={{
                  bgcolor: statusInfo.bg,
                  color: statusInfo.text,
                  fontWeight: 600,
                  fontSize: 12,
                  borderRadius: 2,
                  pointerEvents: "none",
                  px: 1.5,
                }}
              />
            </Grid>

            { (booking.subscription_discount > 0 || booking.promo_discount > 0) && (
              <Grid item xs={12}>
                <Typography fontWeight={600}>Discounts</Typography>
                <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                  {booking.subscription_discount > 0 && (
                    <Chip
                      label={`Sub: -₹${parseFloat(booking.subscription_discount).toFixed(2)}`}
                      size="small"
                      sx={{ bgcolor: "#F3E8FF", color: "#7C3AED", fontWeight: 600 }}
                    />
                  )}
                  {booking.promo_discount > 0 && (
                    <Chip
                      label={`${booking.promo_code}: -₹${parseFloat(booking.promo_discount).toFixed(2)}`}
                      size="small"
                      sx={{ bgcolor: "#D1FAE5", color: "#059669", fontWeight: 600 }}
                    />
                  )}
                </Box>
              </Grid>
            )}
          </Grid>
        </Paper>
      </Container>

      {/* Reports Section */}
      <Container maxWidth="lg" sx={{ mb: 6 }}>
   
  <Typography variant="h5" fontWeight={700} mb={2}>
    Test Details
  </Typography>
    <Grid container spacing={2} sx={{ mb: 4 }}>
    {booking.diagnostic_tests&&(
      <Grid item xs={12} md={6}>

          <Typography variant="subtitle1" fontWeight={600}>
            {booking.diagnostic_tests}
          </Typography>

      </Grid>
    )}
  </Grid>


  <Typography variant="h5" fontWeight={700} mb={2}>
    Diagnostic Reports
  </Typography>
  

  {bookings?.diagnostic_reports &&
  bookings.diagnostic_reports.length > 0 ? (

    <Grid container spacing={2}>
      {bookings.diagnostic_reports.map((report, idx) => {
        const filename = report?.filename || "";
        const originalFilename =
          report?.original_filename ||
          report?.filename ||
          `report_${idx}`;
        const uploadedAt = report?.uploaded_at;
        const fileIcon = getFileIcon(originalFilename);

        return (
          <Grid item xs={12} sm={6} md={4} key={idx}>
            <Card
              sx={{
                border: "2px solid #E5E7EB",
                width: 260,
                borderRadius: 2,
                transition: "all 0.2s",
                "&:hover": {
                  borderColor: "#006D77",
                  boxShadow: "0 4px 12px rgba(0,109,119,0.15)",
                },
              }}
            >
              <CardContent sx={{ p: 2 }}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    textAlign: "center",
                  }}
                >
                  {fileIcon}

                  <Typography
                    variant="body2"
                    fontWeight="600"
                    sx={{ mt: 1, mb: 0.5 }}
                    noWrap
                    title={originalFilename}
                  >
                    {originalFilename.length > 20
                      ? `${originalFilename.substring(0, 20)}...`
                      : originalFilename}
                  </Typography>

                  {uploadedAt && (
                    <Typography
                      variant="caption"
                      color="text.secondary"
                      sx={{ mb: 2 }}
                    >
                      {formatDate(uploadedAt)}
                    </Typography>
                  )}

                  <Stack direction="row" spacing={1}>
                    {/* Preview */}
                    <IconButton
                      size="small"
                      sx={{
                        bgcolor: "#DBEAFE",
                        "&:hover": { bgcolor: "#BFDBFE" },
                      }}
                      onClick={() =>
                        handlePreviewReport(booking.booking_id, 
                    report.filename, 
                    report.file_type,
                    report.original_filename)
                      }
                      
                    >
                      <EyeIcon fontSize="small" sx={{ color: "#2563EB" }} />
                    </IconButton>

                    {/* Download */}
                    <IconButton
                      size="small"
                      sx={{
                        bgcolor: "#D1FAE5",
                        "&:hover": { bgcolor: "#A7F3D0" },
                      }}
                      onClick={() =>
                        handleDownloadReport(
                          booking.booking_id, 
                          report.filename,
                          report.original_filename
                        )
                      }
                      disabled={!filename}
                    >
                      <DownloadIcon
                        fontSize="small"
                        sx={{ color: "#059669" }}
                      />
                    </IconButton>
                  </Stack>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        );
      })}
    </Grid>
  ) : (
    <Paper
      elevation={0}
      sx={{
        p: 3,
        textAlign: "center",
        border: "1px dashed #D1D5DB",
        borderRadius: 2,
      }}
    >
      <Typography color="text.secondary">
        No reports uploaded
      </Typography>
    </Paper>
  )}
     <Grid container spacing={1} mt={3}>
            <Grid item xs={6}>
              <Button
                size="small"
                variant="outlined"
                fullWidth
                onClick={() => handleOpenDialog("feedback", selectedBooking)}
                sx={{
                  borderColor: "#006D77",
                  color: "#006D77",
                  fontSize: 11,
                  fontWeight: 600,
                  textTransform: "none",
                  py: 0.75,
                  "&:hover": { borderColor: "#005761", bgcolor: "rgba(0,109,119,0.08)" }
                }}
              >
                 Feedback
              </Button>
            </Grid>
            <Grid item xs={6}>
              <Button
                size="small"
                variant="outlined"
                fullWidth
                onClick={() => handleInvoiceDownload(booking.booking_id)}
                sx={{
                  borderColor: "#006D77",
                  color: "#006D77",
                  fontSize: 11,
                  fontWeight: 600,
                  textTransform: "none",
                  py: 0.75,
                  "&:hover": { borderColor: "#005761", bgcolor: "rgba(0,109,119,0.08)" }
                }}
              >
                 Download Invoice
              </Button>
            </Grid>

            {canModifyBooking(booking.status) && (
                <Grid item xs={6}>
                  <Button
                    size="small"
                    variant="outlined"
                    fullWidth
                    onClick={() => handleOpenDialog("reschedule", booking)}
                    sx={{
                      borderColor: "#006D77",
                      color: "#006D77",
                      fontSize: 11,
                      fontWeight: 600,
                      textTransform: "none",
                      py: 0.75,
                      "&:hover": {
                        borderColor: "#005761",
                        bgcolor: "rgba(0,109,119,0.08)"
                      }
                    }}
                  >
                    Reschedule
                  </Button>
                </Grid>
              )}

            <Grid item xs={6}>
              <Button
                size="small"
                variant="outlined"
                fullWidth
                onClick={() => handleOpenDialog("complaint", booking)}
                sx={{
                  borderColor: "#006D77",
                  color: "#006D77",
                  fontSize: 11,
                  fontWeight: 600,
                  textTransform: "none",
                  py: 0.75,
                  "&:hover": { borderColor: "#005761", bgcolor: "rgba(0,109,119,0.08)" }
                }}
              >
                 Complaint
              </Button>
            </Grid>
            <Grid item xs={6}>
            {canModifyBooking(booking.status) && (
                <Button
                  size="small"
                  variant="outlined"
                  fullWidth
                  onClick={() => handleOpenDialog("cancel", booking)}
                  sx={{
                    borderColor: "#D97706",
                    color: "#D97706",
                    fontSize: 11,
                    fontWeight: 600,
                    textTransform: "none",
                    py: 0.75,
                    "&:hover": { borderColor: "#B45309", bgcolor: "rgba(217,119,6,0.08)" }
                  }}
                >
                   Cancel
                </Button>
              )}
            </Grid>

            {getCombinedIssues(booking).length > 0 && (
              <Grid item xs={6}>
                <Button
                  size="small"
                  variant="outlined"
                  fullWidth
                  onClick={() => setIssuesDialog({ open: true, booking })}                  sx={{
                    borderColor: "#D97706",
                    color: "#D97706",
                    fontSize: 11,
                    fontWeight: 600,
                    textTransform: "none",
                    py: 0.75,
                    "&:hover": { borderColor: "#B45309", bgcolor: "rgba(217,119,6,0.08)" }
                  }}
                >
                   View Issues  ({getCombinedIssues(booking).length})
                  </Button>
                </Grid>
              )}
          </Grid>
</Container>
     {previewContent && (
                <Box sx={{ mb: 3, textAlign: 'center' }}>
                  {isImageFile(previewContent.filename) ? (
                    <img 
                      src={previewContent.url} 
                      alt={previewContent.filename}
                      style={{ 
                        maxWidth: '100%', 
                        maxHeight: '500px',
                        borderRadius: '8px',
                        border: '2px solid #E5E7EB'
                      }}
                    />
                  ) : isPdfFile(previewContent.filename) ? (
                    <iframe
                      src={previewContent.url}
                      style={{
                        width: '100%',
                        height: '600px',
                        border: '2px solid #E5E7EB',
                        borderRadius: '8px'
                      }}
                      title="PDF Preview"
                    />
                  ) : (
                    <Paper sx={{ p: 4, bgcolor: '#F9FAFB' }}>
                      <FileIcon sx={{ fontSize: 64, color: 'grey.400', mb: 2 }} />
                      <Typography variant="body1" color="text.secondary">
                        Preview not available for this file type
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        Please download the file to view it
                      </Typography>
                    </Paper>
                  )}
                </Box>
              )}
            
      <Footer />
       {/* Preview Dialog */}
            <Dialog
              open={previewDialog.open}
              onClose={handleClosePreview}
              maxWidth="lg"
              fullWidth
              PaperProps={{ sx: { borderRadius: 3 } }}
            >
              <DialogTitle sx={{ bgcolor: "#006D77", color: "white", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <DescriptionIcon />
                  <Typography variant="h6">Report Preview</Typography>
                </Box>
                <IconButton onClick={handleClosePreview} sx={{ color: "white" }}>
                  <CloseIcon />
                </IconButton>
              </DialogTitle>
              <DialogContent sx={{ p: 3 }}>
                {previewDialog.url && (
                  <Box sx={{ textAlign: "center" }}>
                    <Typography variant="h6" fontWeight="600" gutterBottom>
                      {previewDialog.filename}
                    </Typography>
                    
                    {isImageFile(previewDialog.type) ? (
                      <img 
                        src={previewDialog.url} 
                        alt={previewDialog.filename}
                        style={{ 
                          maxWidth: '100%', 
                          maxHeight: '600px',
                          borderRadius: '8px',
                          border: '2px solid #E5E7EB'
                        }}
                      />
                    ) : previewDialog.type === 'pdf' ? (
                      <iframe
                        src={previewDialog.url}
                        style={{
                          width: '100%',
                          height: '600px',
                          border: '2px solid #E5E7EB',
                          borderRadius: '8px'
                        }}
                        title="PDF Preview"
                      />
                    ) : (
                      <Paper sx={{ p: 4, bgcolor: "#F9FAFB" }}>
                        <DescriptionIcon sx={{ fontSize: 64, color: "grey.400", mb: 2 }} />
                        <Typography variant="body1" color="text.secondary">
                          Preview not available for this file type
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          Please download the file to view it
                        </Typography>
                      </Paper>
                    )}
                  </Box>
                )}
              </DialogContent>
            </Dialog>
      {/* Dialog for Feedback/Complaint/Reschedule/Cancel */}
      <Dialog open={dialogOpen} onClose={handleCloseDialog} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: 4 } }}>
        <DialogTitle sx={{ fontSize: 20, fontWeight: 700, color: "#006D77", borderBottom: "1px solid #F3F4F6", textAlign: "center" }}>
          {dialogType === "complaint" && "📝 Raise Complaint"}
          {dialogType === "feedback" && "⭐ Service Feedback"}
          {dialogType === "reschedule" && "🔄 Reschedule Booking"}
          {dialogType === "cancel" && "❌ Cancel Booking"}
        </DialogTitle>
        <DialogContent sx={{ pt: 3 }}>
          {dialogType === "feedback" && (
            <Box>
              <Typography sx={{ mb: 2, fontWeight: 600 }}>How was your experience?</Typography>
              <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
                <Rating
                  value={formData.rating}
                  size="large"
                  onChange={(e, newValue) => setFormData({ ...formData, rating: newValue })}
                />
              </Box>
              <TextField
                label="Share your feedback"
                fullWidth
                multiline
                rows={4}
                value={formData.comment}
                onChange={(e) => setFormData({ ...formData, comment: e.target.value })}
              />
            </Box>
          )}

          {dialogType === "complaint" && (
            <Box>
              <FormControl fullWidth sx={{ mb: 2 }}>
                <InputLabel>Category</InputLabel>
                <Select
                  value={formData.category}
                  onChange={(e) => setFormData({ ...formData, category: e.target.value })}
                  label="Category"
                >
                  <MenuItem value="service delay">Service Delay</MenuItem>
                  <MenuItem value="staff issue">Staff Issue</MenuItem>
                  <MenuItem value="quality issue">Quality Issue</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                </Select>
              </FormControl>
              <TextField
                label="Describe your complaint"
                fullWidth
                multiline
                rows={4}
                value={formData.comment}
                onChange={(e) => setFormData({ ...formData, comment: e.target.value })}
              />
            </Box>
          )}

          {dialogType === "reschedule" && (
            <Box>
              <Typography sx={{ mb: 2, fontWeight: 600 }}>
                Service: {selectedBooking?.service_type}
              </Typography>
              <TextField
                label="Select New Date & Time"
                type="datetime-local"
                fullWidth
                InputLabelProps={{ shrink: true }}
                value={convertOffsetISOToLocalInput(formData.date)}
                // onChange={(e) => setFormData({ ...formData, date: e.target.value })}
                onChange={(e) => {
                  const value = e.target.value; // "2026-02-28T15:05"
                  if (!value) return;

                  const offset = new Date().getTimezoneOffset();
                  const sign = offset <= 0 ? "+" : "-";
                  const absOffset = Math.abs(offset);
                  const hours = String(Math.floor(absOffset / 60)).padStart(2, "0");
                  const minutes = String(absOffset % 60).padStart(2, "0");

                  const formatted = `${value}:00${sign}${hours}:${minutes}`;
                console.log(formatted)
                  setFormData({ ...formData, date: formatted });}}
                inputProps={{
                  min: minDateTime,
                  max: maxDateTime
                }}
                sx={{ mb: 2 }}
              />
                <TextField
                  fullWidth
                  multiline
                  minRows={3}
                  label="Reason for Reschedule"
                  value={formData.reschedule_reason}
                  onChange={(e) =>
                    setFormData({ ...formData, reschedule_reason: e.target.value })
                  }
                  placeholder="Eg: Patient not available, requested different time"
                  sx={{ mt: 2 }}
                />

            </Box>
          )}

          {dialogType === "cancel" && (
            <Box sx={{ textAlign: "center", py: 2 }}>
              <Typography sx={{ fontSize: 18, fontWeight: 600, color: "#DC2626", mb: 2 }}>
                ⚠️ Are you sure you want to cancel this booking?
              </Typography>
              <TextField
                label="Cancellation Reason"
                multiline
                required
                rows={3}
                fullWidth
                value={formData.cancellation_reason || ""}
                onChange={(e) =>
                  setFormData({ ...formData, cancellation_reason: e.target.value })
                }
              />
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 2.5, borderTop: "1px solid #F3F4F6" }}>
          <Button onClick={handleCloseDialog} sx={{ color: "#6B7280", textTransform: "none" }}>
            Close
          </Button>
          <Button
            variant="contained"
            onClick={handleSubmit}
            disabled={loading}
            sx={{
              bgcolor: dialogType === "cancel" ? "#DC2626" : "#006D77",
              textTransform: "none",
              minWidth: 120,
              "&:hover": { bgcolor: dialogType === "cancel" ? "#B91C1C" : "#005A63" },
            }}
          >
            {loading ? <CircularProgress size={24} sx={{ color: "#fff" }} /> : dialogType === "cancel" ? "Yes, Cancel" : "Submit"}
          </Button>
        </DialogActions>
      </Dialog>
       {/* Validation Dialog */}
            <Dialog open={validationDialogOpen} onClose={() => setValidationDialogOpen(false)} maxWidth="xs" fullWidth>
              <DialogContent sx={{ textAlign: "center", py: 4 }}>
                <Typography sx={{ fontSize: 48, mb: 2 }}>
                  {validationMessage.includes("success") || validationMessage.includes("Success") ? "✅" : "ℹ️"}
                </Typography>
                <Typography sx={{ fontSize: 16, fontWeight: 600, color: "#111827" }}>
                  {validationMessage}
                </Typography>
              </DialogContent>
              <DialogActions sx={{ justifyContent: "center", pb: 3 }}>
                <Button
                  variant="contained"
                  onClick={() => setValidationDialogOpen(false)}
                  sx={{
                    bgcolor: "#006D77",
                    textTransform: "none",
                    px: 4,
                    "&:hover": { bgcolor: "#005A63" }
                  }}
                >
                  OK
                </Button>
              </DialogActions>
            </Dialog>
      
       {/* Custom Dialog */}
            <CustomDialog
              open={customDialog.show}
              message={customDialog.message}
              title={customDialog.title}
              type={customDialog.type}
              onClose={handleCloseCustomDialog}
              buttonText="OK"
            />
    </Box>
  );
};

export default BookingDetailsPage;